import { capitalFirstLetter } from "./capitalFirstLetter";

export const getImageUrl = (
  name: string | undefined,
  country: string | undefined
) =>
  `/assets/images/png/universities/${capitalFirstLetter(
    country ?? ""
  )}/${name}/Gallery/${name}_Image_1.png`;

export const getImageBanner = (name: string | undefined, country: string) =>
  `/assets/images/png/universities/${capitalFirstLetter(
    country ?? ""
  )}/${name}/Media/${name}_Banner.png`;

export const getCampusImageUrl = (
  name: string | undefined,
  campusName: string | undefined,
  country: string | undefined
) => {
  const formattedName = campusName?.replace(/\s+/g, "_");
  return `/assets/images/png/universities/${capitalFirstLetter(
    country ?? ""
  )}/${name}/Campus/${formattedName}/${formattedName}1.png`;
};
